export default __webpack_public_path__ + "static/media/15-ThreeMileCreek.ebf0b6a6.jpeg";